import { render, staticRenderFns } from "./CollectionActions.vue?vue&type=template&id=682701e6&scoped=true&"
import script from "./CollectionActions.vue?vue&type=script&lang=ts&"
export * from "./CollectionActions.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionActions.vue?vue&type=style&index=0&id=682701e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682701e6",
  null
  
)

export default component.exports